/**
 * Announcement Bar Slider
 * Desktop + Mobile slider
 * Slider enabled only if items > 1
 */
(function () {
  'use strict';

  class AnnouncementBarSlider {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.announcement-bar--slider-track');
      this.slides = Array.from(container.querySelectorAll('.announcement-bar--slide'));
      this.dots = Array.from(container.querySelectorAll('.announcement-bar--slider-dot'));
      this.prevButton = container.querySelector('.announcement-bar--slider-prev');
      this.nextButton = container.querySelector('.announcement-bar--slider-next');

      const autoplayAttr = container.getAttribute('data-autoplay-speed');
      this.autoplaySpeed = autoplayAttr
        ? parseInt(autoplayAttr, 10) * 1000
        : 5000;

      this.totalSlides = this.slides.length;
      this.slidesPerView = 1;
      this.currentIndex = 0;
      this.maxIndex = Math.max(0, this.totalSlides - this.slidesPerView);

      this.autoplayTimer = null;
      this.isTransitioning = false;

      /* ❌ Disable slider if only 1 item */
      if (this.totalSlides <= 1) {
        if (this.prevButton) this.prevButton.style.display = 'none';
        if (this.nextButton) this.nextButton.style.display = 'none';

        const dotsContainer = container.querySelector('.announcement-bar--slider-dots');
        if (dotsContainer) dotsContainer.style.display = 'none';

        return;
      }

      this.init();
    }

    init() {
      this.updateSlides();
      this.attachEvents();
      this.startAutoplay();
    }

    attachEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      /* Pause autoplay on hover */
      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => this.startAutoplay());

      window.addEventListener('resize', () => this.handleResize());
    }

    handleResize() {
      const newMaxIndex = Math.max(0, this.totalSlides - 1);

      if (this.maxIndex !== newMaxIndex) {
        this.maxIndex = newMaxIndex;

        if (this.currentIndex > this.maxIndex) {
          this.currentIndex = this.maxIndex;
        }

        this.updateSlides();
      }
    }

    updateSlides() {
      if (!this.track) return;

      const translateX = -this.currentIndex * 100;
      this.track.style.transform = `translateX(${translateX}%)`;

      this.updateDots();
      this.updateButtons();
    }

    updateDots() {
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.currentIndex);
      });
    }

    updateButtons() {
      if (this.prevButton) {
        this.prevButton.style.opacity = this.currentIndex === 0 ? '0.3' : '0.7';
        this.prevButton.style.pointerEvents =
          this.currentIndex === 0 ? 'none' : 'auto';
      }

      if (this.nextButton) {
        this.nextButton.style.opacity =
          this.currentIndex >= this.maxIndex ? '0.3' : '0.7';
        this.nextButton.style.pointerEvents =
          this.currentIndex >= this.maxIndex ? 'none' : 'auto';
      }
    }

    prev() {
      if (this.isTransitioning || this.currentIndex === 0) return;
      this.currentIndex -= 1;
      this.slide();
    }

    next() {
      if (this.isTransitioning || this.currentIndex >= this.maxIndex) return;
      this.currentIndex += 1;
      this.slide();
    }

    goToSlide(index) {
      if (this.isTransitioning) return;
      this.currentIndex = index;
      this.slide();
    }

    slide() {
      this.isTransitioning = true;
      this.updateSlides();
      this.stopAutoplay();

      setTimeout(() => {
        this.isTransitioning = false;
        this.startAutoplay();
      }, 500);
    }

    startAutoplay() {
      this.stopAutoplay();

      if (this.autoplaySpeed > 0 && this.totalSlides > 1) {
        this.autoplayTimer = setInterval(() => {
          this.currentIndex =
            this.currentIndex >= this.maxIndex ? 0 : this.currentIndex + 1;
          this.slide();
        }, this.autoplaySpeed);
      }
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  /* Init sliders */
  function initSliders() {
    document
      .querySelectorAll('.announcement-bar--slider')
      .forEach(slider => new AnnouncementBarSlider(slider));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  /* Shopify theme editor support */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', event => {
      const slider = event.target.querySelector('.announcement-bar--slider');
      if (slider) new AnnouncementBarSlider(slider);
    });
  }
})();